var _defs, _path, _path2, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeelungVideoBackgroundv1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sea",
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e3e5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sea)",
    d: "M0 0h640v360H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7dadb",
    opacity: 0.6,
    d: "M0 302Q160 260 320 304T640 292v68H0z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 42,
    fill: "#45666d",
    fontFamily: "sans-serif",
    fontSize: 18,
    letterSpacing: 2
  }, "\u57FA\u9686\u89AA\u5B50\u7167\u8B77")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 29,
    y: 63,
    fill: "#57777d",
    fontFamily: "sans-serif",
    fontSize: 10,
    letterSpacing: 3
  }, "KEELUNG CARE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeelungVideoBackgroundv1);
export default __webpack_public_path__ + "static/media/keelung-video-background.v1.55da58042791b379b652d21fe76cefff.svg";
export { ForwardRef as ReactComponent };